import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogArticle from "@/pages/blog/article/page";
import TemplatesArticle from "@/pages/blog/templates/page";
import ReviewsArticle from "@/pages/blog/reviews/page";
import ComparisonsArticle from "@/pages/blog/comparisons/page";
import ShoppingGuide from "@/pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/what-is-vigorbuy-spreadsheet-complete-guide",
    element: <BlogArticle />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-templates",
    element: <TemplatesArticle />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-reviews",
    element: <ReviewsArticle />,
  },
  {
    path: "/blog/vigorbuy-spreadsheet-comparisons",
    element: <ComparisonsArticle />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;